import { cn } from "../../lib/cn.js";

export type FormGridColumns = 1 | 2 | 3 | 4;
export type FormRootSize = "sm" | "md" | "lg" | "xl" | "full";
export type FormActionsVariant = "inline" | "panel" | "sticky";

const GRID_COLUMN_CLASS_NAMES: Record<FormGridColumns, string | undefined> = {
  1: undefined,
  2: "md:grid-cols-2",
  3: "md:grid-cols-2 xl:grid-cols-3",
  4: "sm:grid-cols-2 xl:grid-cols-4",
};

const ROOT_SIZE_CLASS_NAMES: Record<FormRootSize, string> = {
  sm: "max-w-2xl",
  md: "max-w-3xl",
  lg: "max-w-5xl",
  xl: "max-w-6xl",
  full: "max-w-none",
};

const ACTION_VARIANT_CLASS_NAMES: Record<FormActionsVariant, string> = {
  inline: "flex flex-col-reverse gap-2 pt-1 sm:flex-row sm:items-center sm:justify-end",
  panel:
    "flex flex-col-reverse gap-2 border-t border-border/60 bg-muted/20 px-5 py-4 sm:flex-row sm:items-center sm:justify-end",
  sticky:
    "sticky bottom-0 z-20 flex flex-col-reverse gap-2 border-t border-border/60 bg-card/95 px-5 py-4 shadow-sm backdrop-blur sm:flex-row sm:items-center sm:justify-end",
};

export function getFormGridClassName(columns: FormGridColumns = 1, className?: string): string {
  // items-start so each cell pins its label/control to the top of the row —
  // otherwise a taller cell (e.g. a field with helper text) stretches its
  // neighbours and their labels drift out of alignment.
  return cn("grid items-start gap-4", GRID_COLUMN_CLASS_NAMES[columns], className);
}

export function getFormRootClassName(size: FormRootSize = "lg", className?: string): string {
  return cn("grid w-full gap-5", ROOT_SIZE_CLASS_NAMES[size], className);
}

export function getFormActionsClassName(
  variant: FormActionsVariant = "inline",
  className?: string,
): string {
  return cn(ACTION_VARIANT_CLASS_NAMES[variant], className);
}
